import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="testimonials-heading" data-id="element-158" data-mp="3fycrjpy4ubcd">
      <div className="mx-auto max-w-6xl px-5" data-id="element-159" data-mp="3azjcvu740eam">
        <div id="testimonials-heading" data-id="element-160" data-mp="3ayqdjeahcr2i">
          <SectionHeading eyebrow="Loved by moms and kids" title="See what moms are saying after getting My Magical World of Paper" data-id="element-161" data-mp="36z96whjbhnvr" />
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-162" data-mp="2x0jl4doavja8">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.author} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="flex flex-col rounded-3xl border-2 border-white bg-white p-6 shadow-card" data-id="element-163" data-mp="2s2i5y3tzw441" data-mpi={index}>
              <div className="flex gap-0.5 text-sun-500" aria-label="5 out of 5 stars" data-id="element-164" data-mp="m5kmap8g0vcy">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-165" data-mp="79v8vfhbpqju" data-mpi={starIndex} />)}
              </div>
              <blockquote className="mt-3 flex-1 text-sm italic leading-relaxed text-ink/80" data-id="element-166" data-mp="14vj3pvy4s0t9">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-4 font-display font-bold text-blush-500" data-id="element-167" data-mp="q6cv5hdeky8p">
                — {testimonial.author}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}